<template>
    <div>
        <div class="form-group row">
            <label :for="id ? (id + '_amount') : 'amount'" class="col-sm-4 col-form-label required">Prix de revient</label>
            <div class="col-sm-8">
                <div class="input-group">
                    <input type="number" step="0.01" class="form-control" :id="id ? (id + '_amount') : 'amount'" :name="id ? (id + '[amount]') : 'amount'" required @blur="compute(null)" v-model="amount">
                    <div class="input-group-append">
                        <span class="input-group-text">€</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label :for="id ? (id + '_amount') : 'amount'" class="col-sm-4 col-form-label required">Taux de {{ marginType == 2 ? 'marque' : 'marge' }}</label>
            <div class="col-sm-8">
                <div class="input-group">
                    <input type="number" step="0.01" class="form-control" :id="id ? (id + '_margin') : 'margin'" :name="id ? (id + '[margin]') : 'margin'" required @blur="compute('margin')" v-model="margin">
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label :for="id ? (id + 'selling') : 'selling'" class="col-sm-4 col-form-label required">Prix de vente HT</label>
            <div class="col-sm-8">
                <div class="input-group">
                    <input type="number" step="0.01" class="form-control" :id="id ? (id + '_selling') : 'selling'" :name="id ? (id + '[selling]') : 'selling'" required @blur="compute('selling')" v-model="selling">
                    <div class="input-group-append">
                        <span class="input-group-text">€</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'price-form',
        props: ['id', 'initialAmount', 'initialMargin', 'initialSelling', 'marginType'],
        data() {
            return {
                errors: [],
                amount: 0,
                margin: 0,
                selling: 0
            };
        },
        methods : {
            computeSelling: function () {
                if (this.marginType == 2) {
                    return this.roundCurrency((parseFloat(this.amount)/(100 - parseFloat(this.margin))) * 100, 2)
                } else {
                    var marginTotal = (parseFloat(this.amount) / 100) * parseFloat(this.margin)
                    return this.roundCurrency((parseFloat(this.amount) + marginTotal), 2)
                }
            },
            computeMargin: function () {
                var marginDiff = parseFloat(this.selling) - parseFloat(this.amount)

                if (this.marginType == 2) {
                    if (parseFloat(this.selling) != 0) {
                        var divider = parseFloat(this.selling);
                    } else {
                        return 0;
                    }
                } else {
                    if (parseFloat(this.amount) != 0) {
                        var divider = parseFloat(this.amount);
                    } else {
                        return 0;
                    }
                }

                return this.roundCurrency((marginDiff/divider) * 100, 2)
            },
            compute: function(from) {
                // Prévention champs vide
                if (this.amount == '' || this.amount == null) { this.amount = 0 }
                if (this.margin == '' || this.margin == null) { this.margin = 0 }
                if (this.selling == '' || this.selling == null) { this.selling = 0 }

                if (from == null || from == 'margin') {
                    this.selling = this.computeSelling()
                } else if (from == 'selling') {
                    this.margin = this.computeMargin() 
                }
            },
        },
        mounted() {
            this.amount = parseFloat(this.initialAmount)
            this.margin = parseFloat(this.initialMargin)
            this.selling = parseFloat(this.initialSelling)
        }
    }
</script>
